import React from 'react';
import { Table } from 'antd';
import './listViewWithoutExpand.scss';

type Props = {
  className?: any;
  dataSource: any;
  columns?: any;
  items: any;
  limit?: any;
  scrollY?: number;
  component?: string;
};

type TablePaginationPosition =
  | 'topLeft'
  | 'topCenter'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomCenter'
  | 'bottomRight';

const ListViewWithoutExpand = (props: Props) => {
  return (
    <Table
      rowKey={(record: any) => record.id}
      dataSource={props?.dataSource}
      columns={props?.columns}
      scroll={
        props.component === 'cash purchase' ||
        props.component === 'purchase order' ||
        props.component === 'stock request' ||
        props.component === 'supplier'
          ? { y: props.scrollY }
          : undefined
      }
      pagination={{
        pageSize: props?.limit || 20,
        position: [
          'none' as TablePaginationPosition,
          'none' as TablePaginationPosition,
        ],
      }}
    />
  );
};

export default ListViewWithoutExpand;
